export const SET_LOADING = 'SET_LOADING';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_CREDENCIAL = 'SET_CREDENCIAL';
export const SET_EMBEDDED = 'SET_EMBEDDED';
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER';
export const SET_SELECT_OPTIONS = 'SET_SELECT_OPTIONS';

export const DISABLE_ENABLE_FIELDS = 'DISABLE_ENABLE_FIELDS';
export const ENABLE_ALL_FIELDS = 'ENABLE_ALL_FIELDS';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const SET_SUBMITTING_PROGRESS = 'SET_SUBMITTING_PROGRESS';
export const CLEAN_SUBMITTING = 'CLEAN_SUBMITTING';
export const SET_MODULES = 'SET_MODULES';
export const SET_FIRST_RENDER = 'SET_FIRST_RENDER';